import { render, staticRenderFns } from "./CapitalShiftToHistory.vue?vue&type=template&id=a7bb60b0&scoped=true&"
import script from "./CapitalShiftToHistory.vue?vue&type=script&lang=ts&"
export * from "./CapitalShiftToHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CapitalShiftToHistory.vue?vue&type=style&index=0&id=a7bb60b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bb60b0",
  null
  
)

export default component.exports